var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bullet-steps"},[_c('span',{class:{ 'item bullet-1': true, active: _vm.step >= 1 }}),_c('span',{class:{ 'item bullet-2': true, active: _vm.step >= 2 }}),_c('span',{class:{ 'item bullet-3': true, active: _vm.step >= 3 }})])
}
var staticRenderFns = []

export { render, staticRenderFns }